import { AlertColor, Grid, Typography } from '@mui/material';

const COLORS = {
  "SKY":"#D4F6FF",
  "GREEN":"#D1F8EF",
  "WHITE":"#FFFFFF",
  "RED":"#FFCDD2",
  "GRAY":"#ececec",
  "YELLOW":"#fff59d",
  "ORANGE":"#ff5c00",
  "PRUEBA": "#a3a8d0",
}

export type CardPersonalizadoProps= {
  alertTitle?: string;
  alertMessage?: string;
  alertContentNode?: React.ReactNode;
  alertColor?: AlertColor;
  bgColorAlert?: "SKY"|"GREEN"|"WHITE"|"RED"|"GRAY"|"YELLOW"|"ORANGE"|"PRUEBA"
};

const CardPersonalizado: React.FC<CardPersonalizadoProps> = ({
  alertTitle = 'INFORMACIÓN',
  alertMessage = '',
  alertContentNode,
  bgColorAlert
}) => {

  const renderBolbeforcolon = (mesaje: string) => {
      return mesaje.split('\n').map((line, idx) => {
      const [beforeColon, ...afterColonParts] = line.split(':');
      const afterColon = afterColonParts.join(':');
      if (afterColonParts.length > 0) {
        return (
          <span key={idx}>
            <span style={{ fontWeight: 700 }}>{beforeColon}:</span>{afterColon}
            <br />
          </span>
        );
      } else {
        return (
          <span key={idx}>
            {line}
            <br />
          </span>
        );
      }
    });
  }


  return (
    <>
      <Grid item xs={12}
        sx={{
            background: bgColorAlert ? COLORS[bgColorAlert] : COLORS["GRAY"],
            padding: 2
        }}
      >
          <Grid container>
            <Grid item xs={12}>
              {alertContentNode ? (
                alertContentNode
              ) : (
                <Typography variant="body1" sx={{
                    color:bgColorAlert?"black":undefined,
                whiteSpace: "pre-line",
            }}> <span style={{fontWeight: 700}}>{alertTitle}</span>:  
              {renderBolbeforcolon(alertMessage)}
               </Typography>
              )}
            </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CardPersonalizado;
